<div class="row justify-content-center bgColor">
	<div class="col-11">
		<div class="innerDivBg my-4">
			<div class="innerDiv text-center py-5">
				<h1>Need Help? Contact Us</h1>
				<p>Reach out to us for questions, assistance, complaints and suggestions.</p>
			</div>
			<div class="row justify-content-center">
				<div class="col-md-9 mt-4 mb-5">
					<div class="row justify-content-center">
						<div class="col-md-4">
							<div class="card myCard">
							  <img class="img-fluid" src="./assets/img/Phone.svg">
							  <div class="card-body text-center myCardBody">
							  	<h5>PHONE</h5>
							  	<p>022-39612435</p>
							  </div>
							</div>
						</div>
						<div class="col-md-4">
							<div class="card myCard">
							  <img class="img-fluid" src="./assets/img/Address.svg">
							  <div class="card-body text-center myCardBody">
							  	<h5>ADDRESS</h5>
							  	<p><b>ARRIVAE</b>, B 501/502, Everest House, Surren Road, Gundavali, Andheri East, Mumbai, Maharashtra - 400093</p>
							  </div>
							</div>
						</div>
						<div class="col-md-4">
							<div class="card myCard">
							  <img class="img-fluid" src="./assets/img/mail.svg">
							  <div class="card-body text-center myCardBody">
							  	<h5>EMAIL</h5>
							  	<p>wecare@arrivae.com</p>
							  </div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>


// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/customer/contact/contact.component.html